import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import uuidv4 from 'uuid/v4';

import { setChargeAmount } from '../reducer/chargeAmount/actions';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import {
  getGiftCard,
  getGiftCardBalance,
  getGiftCardBarberName,
  getInsufficientFunds,
} from '../reducer/giftCard/selectors';
import { setGiftCard } from '../reducer/giftCard/actions';
import GiftCard from '../components/GiftCard';
import { getShop } from '../../../auth/selectors';
import { fetchGiftCardByCode } from '../../giftCards/actions';
import { PAYMENT_TYPE } from '../../../main/payment/constants';
import { getOrderForValidation } from '../../selectors';
import withValidateSaleAction from '../../hoc/withValidateSaleAction';
import { fullName } from '../../../common/helpers/users';
import httpErrorCodeMap from '../../../httpErrorCodeMap';

const GiftCardContainer = compose(
  withValidateSaleAction,
  connect(
    (state) => {
      const code = getGiftCard(state);
      return {
        code,
        balance: getGiftCardBalance(state),
        hasGiftCard: Boolean(code),
        insufficientFunds: getInsufficientFunds(state),
        shopId: getShop(state),
        chargeAmount: getChargeAmount(state),
        order: getOrderForValidation(state),
        barberName: getGiftCardBarberName(state),
      };
    },
    { setGiftCard, setChargeAmount }
  ),
  withState('value', 'setValue', props => props.code),
  withState('maxAmount', 'setMaxAmount', 0),
  withHandlers({
    reset: props => () => props.setGiftCard(),
    onChange: props => e => props.setValue(e.target.value),
    onSubmit: props => async (e) => {
      e.preventDefault();

      try {
        const gc = await fetchGiftCardByCode(props.shopId, props.value);
        props.setGiftCard();

        const payment = {
          id: uuidv4(),
          type: PAYMENT_TYPE.giftCard,
          code: props.value,
          amount: props.chargeAmount,
          balance: props.outstandingBalance,
        };
        try {
          await props.validateSaleAction(({
            ...props.order,
            payments: [
              ...props.order.payments,
              payment,
            ],
          }));
        } catch (validationError) {
          switch (validationError.code) {
            case httpErrorCodeMap.giftCardCanOnlyBeUsedToCoverAssignedBarberAmount: {
              props.setMaxAmount(validationError.maxAmount);
              props.setChargeAmount(validationError.maxAmount);
              break;
            }
            case httpErrorCodeMap.giftCardInsufficientFunds: {
              if (validationError.maxAmount === 0) {
                throw validationError;
              }
              props.setChargeAmount(validationError.maxAmount);
              break;
            }
            default:
              throw validationError;
          }
        }

        props.setGiftCard(
          props.value,
          gc.outstandingBalance,
          fullName(gc.barber),
          gc.barberId,
        );
      } catch (err) {
        props.setGiftCard();
      }
    },
  }),
  withPropsOnChange(
    ['balance'],
    (props) => {
      if (
        props.hasGiftCard &&
        props.balance && props.balance < props.chargeAmount
      ) {
        props.setChargeAmount(props.balance);
      }
    }
  )
)(GiftCard);

export default GiftCardContainer;
